import { render, staticRenderFns } from "./ProjectActionMenu.vue?vue&type=template&id=52efa85c&scoped=true&"
import script from "./ProjectActionMenu.vue?vue&type=script&lang=js&"
export * from "./ProjectActionMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52efa85c",
  null
  
)

export default component.exports